import { useQuery } from "@tanstack/react-query";
import { getConfig } from "@/lib/api";

export function useSiteConfig() {
  return useQuery({
    queryKey: ["site-config"],
    queryFn: getConfig,
    staleTime: 60_000,
    retry: 1,
  });
}
